module.exports = __webpack_public_path__ + "img/WandaPlaza.d8823d29.png";